export default __webpack_public_path__ + "static/media/mouseRightClick.1356be6e.png";